import { useCallback, useSyncExternalStore } from 'react'

const PRINTER_IP_KEY = 'printerIp'
const PRINTER_NAME_KEY = 'printerName'

const subscribe = (callback: () => void) => {
  window.addEventListener('storage', callback)
  return () => window.removeEventListener('storage', callback)
}

const getPrinterIpSnapshot = () => localStorage.getItem(PRINTER_IP_KEY) ?? ''
const getPrinterNameSnapshot = () => localStorage.getItem(PRINTER_NAME_KEY) ?? ''

export const usePrinter = () => {
  const printerIp = useSyncExternalStore(subscribe, getPrinterIpSnapshot)
  const printerName = useSyncExternalStore(subscribe, getPrinterNameSnapshot)

  const setPrinterIp = useCallback((value: string) => {
    localStorage.setItem(PRINTER_IP_KEY, value)
    window.dispatchEvent(new StorageEvent('storage', { key: PRINTER_IP_KEY }))
  }, [])

  const setPrinterName = useCallback((value: string) => {
    localStorage.setItem(PRINTER_NAME_KEY, value)
    window.dispatchEvent(new StorageEvent('storage', { key: PRINTER_NAME_KEY }))
  }, [])

  return { printerIp, printerName, setPrinterIp, setPrinterName }
}
